module.exports = __webpack_public_path__ + "img/RPS_Logo.b565bd96.png";